<dictionaries-layout [title]="title" [type]="dictionaryType">
  <div class="parameters-data-wrapper">
    <fca-data-table
      *ngIf="data"
      [dataDefinition]="dataDefinition"
      [data]="data"
      [onItemUpdate]="updateParameter"
      [pageSize]="pageSize"
      [editModeType]="'single'"
    ></fca-data-table>
    <div *ngIf="data == null" class="no-data-placeholder">No data</div>
  </div>

  <button mat-flat-button class="add-button" (click)="addParameter()">
    Add new
  </button>
</dictionaries-layout>
